import styled, { DefaultTheme } from 'styled-components';

type Props = {
  $variant: string;
};

type StyleProps = Props & {
  theme: DefaultTheme;
};

// Handle background color
function handleBackground({ theme, $variant }: StyleProps) {
  switch ($variant) {
    case 'transparent':
      return 'transparent';
    case 'secondary':
      return theme.colors.background;
    case 'danger':
      return theme.colors.error;
    default:
      return theme.colors.primary;
  }
}

// Handle background color on hover
function handleHoverBackground({ theme, $variant }: StyleProps) {
  switch ($variant) {
    case 'primary':
      return theme.colors.brand110;
    case 'danger':
      return theme.colors.error110;
    default:
      return theme.colors.brand5;
  }
}

// Handle color
function handleColor({ theme, $variant }: StyleProps) {
  switch ($variant) {
    case 'transparent':
    case 'secondary':
      return theme.colors.brand;
    default:
      return theme.colors.onPrimary;
  }
}

// Handle border
function handleBorder({ theme, $variant }: StyleProps) {
  if ($variant === 'secondary') {
    return `1px solid ${theme.colors.primary}`;
  }

  return 'none';
}

export const StyledButton = styled.button<Props>`
  width: 100%;
  height: 56px;
  background-color: ${handleBackground};
  color: ${handleColor};
  font-size: 16px;
  line-height: 16px;
  font-weight: 600;
  text-decoration: none;
  padding: 16px;
  border: ${handleBorder};
  border-radius: 8px;
  margin: 0;
  opacity: ${({ disabled }) => (disabled ? 0.32 : 1)};
  cursor: pointer;

  &:hover {
    background-color: ${handleHoverBackground};
  }

  &:disabled {
    cursor: default;
  }
`;
